import { requireNonNullable } from '@disy/lib/custom-error';
import { getDisyNamespace } from '@disy/lib/disy';

export function getCurrentLanguage() {
  return requireNonNullable(getDisyNamespace().language);
}

export function getCurrentLocale() {
  return requireNonNullable(getDisyNamespace().locale);
}

let collator: Intl.Collator | undefined;

/** @see net/disy/commons/core/collator/CadenzaCollator.java */
export function compareWithLocale(a: string, b: string) {
  if (!collator) {
    collator = new Intl.Collator(getCurrentLocale());
  }
  return collator.compare(a, b);
}

// for testing
export function __unsetCollator__() {
  collator = undefined;
}
